import { httpsCallable } from 'firebase/functions';
import { functions } from './firebase';

export type AdminRecord = {
  uid: string;
  email?: string | null;
  createdAt?: string | null;
  createdBy?: string | null;
};

export const adminService = {
  async listAdmins(): Promise<AdminRecord[]> {
    const callable = httpsCallable(functions, 'listAdmins');
    const res = await callable({});
    const data = (res.data as any) || {};
    return Array.isArray(data.admins) ? (data.admins as AdminRecord[]) : [];
  },

  async addAdminByEmail(email: string, options?: { setClaim?: boolean }): Promise<{ uid: string; email: string }> {
    const callable = httpsCallable(functions, 'addAdminByEmail');
    const res = await callable({
      email,
      setClaim: options?.setClaim === true,
    });
    const data = (res.data as any) || {};
    if (!data.success) {
      throw new Error('Echec addAdminByEmail');
    }
    return { uid: String(data.uid || ''), email: String(data.email || email) };
  },

  async addAdminByUid(uid: string, options?: { setClaim?: boolean }): Promise<{ uid: string }> {
    const callable = httpsCallable(functions, 'addAdminByUid');
    const res = await callable({
      uid,
      setClaim: options?.setClaim === true,
    });
    const data = (res.data as any) || {};
    if (!data.success) {
      throw new Error('Echec addAdminByUid');
    }
    return { uid: String(data.uid || uid) };
  },

  async removeAdminByUid(uid: string, options?: { removeClaim?: boolean }): Promise<{ uid: string }> {
    const callable = httpsCallable(functions, 'removeAdminByUid');
    const res = await callable({
      uid,
      removeClaim: options?.removeClaim === true,
    });
    const data = (res.data as any) || {};
    if (!data.success) {
      throw new Error('Echec removeAdminByUid');
    }
    return { uid: String(data.uid || uid) };
  },
};

export default adminService;
